import * as React from 'react'
import { Link } from 'react-router-dom'
import Page from '../components/layout/Page'
import Container from '../components/layout/Container'
import styled from '../utils/styled'
import FullSizeSection from '../components/layout/FullSizeSection'

export default () => (
  <Page>
    <Container>
      <PageContent className="container-fluid">
        <FullSizeSection
          title="C-LAB"
          subtitle="Bio art Collective"
          className=""
          backgroundImage={require('../images/front-stressostat.jpg')}
        >
          C-LAB is a London-based transdisciplinary collective that uses unconventional material and emerging technologies to create unique art experiences. Installations combine the use of software, hardware and biotechnology.
          <br />
          <br />
          Primary artists are <Link to={'/authors/howard_boland'}>Dr Howard Boland</Link> &{' '}
          <Link to={'/authors/laura_cinti'}>Dr Laura Cinti</Link>.
        </FullSizeSection>
        <FullSizeSection
          title="About"
          media={{ url: 'jmKqcpQ7ak8', type: 'youtube' }}
          subtitle="Research-based Art"
          className="theme-dark"
        >
          C-LAB’s practice has been focused on the modification of biological matter to create living artworks. This practice is sometimes referred to as bio art.
          <br />
          <br />
          Bio art is an emerging and uncertain area, where art meets biotechnology. Some of its main characteristics can be traced to the use of material and processes that require specialised bio-scientific knowledge and having to deal with institutions, regulations, safety and ethical frameworks.
        </FullSizeSection>
        <FullSizeSection
          title="Artworks"
          media={{ url: '1IkY0_qONRk', type: 'youtube' }}
          subtitle="Project-based art"
          className="dark"
        >
          C-LAB’s early works focused on the poetic negotiation of scientific spaces but over the years its practice has intersected with a wide set of research areas such as: synthetic biology, genetics, ecology, environmental and space sciences.
          <br />
          <br />
          C-LAB invests in projects and subject areas with artworks, writing and experiments as outcomes.
        </FullSizeSection>
        <FullSizeSection
          title="Context"
          subtitle="Living Material"
          media={{ url: 'SracqCkXKlU', type: 'youtube' }}
          className=""
          // backgroundImage={require('../images/front.jpg')}
        >
        C-LAB is situated within bio art practices and makes use of genetic modification in several of the works.
<br />
<br />
Living material offers exciting ways of experiencing art and the life world. Our approach incorporates scientific methods and tools in order to manipulate living material as a way of experiencing deeper and often inaccessible biological processes.
<br />
<br />
We believe that these types of artworks should be exhibited as living material rather than recordings when possible.
        </FullSizeSection>
      </PageContent>
    </Container>
  </Page>
)

const PageContent = styled('article')`
  /* max-width: ${props => props.theme.widths.md}; */
  margin: 0 auto;
  perspective: 2px;
  /* line-height: 1.6; */
  /* margin: 0; */
  padding: 0;

  a {
    color: ${props => props.theme.colors.brand};
  }

  h1,
  h2,
  h3,
  h4 {
    /* margin-bottom: 0.5rem; */
    /* font-family: ${props => props.theme.fonts.headings}; */
    /* line-height: 1.25; */
  }
`
